<template>
    <TransactionalScreen class="bg-light" :title="$t('verify.title')" @setLanguage="setLanguage" hideLogo clickableLogo @clickOnLogo="$router.push({ name: 'login' })">
        <p class="mb-5">{{ $t('verify.intro') }}</p>
        <FormRoot class="text-left" @submit="submit">

            <!-- Last name and first name -->
            <Field
                    :form.sync="form"
                    name="last_name"
                    :placeholder="$t('verify.last_name')"
                    :hint="$t('verify.last_name_hint')"
            />
            <Field
                    :form.sync="form"
                    name="first_name"
                    :placeholder="$t('verify.first_name')"
                    :hint="$t('verify.first_name_hint')"
            />

            <!-- E-mail -->
            <Field
                    :form.sync="form"
                    name="email"
                    :placeholder="$t('verify.email')"
                    :hint="$t('verify.email_hint')"
            />

            <!-- Phone -->
            <Field
                    :form.sync="form"
                    type="phone"
                    name="phone"
                    :placeholder="$t('verify.phone')"
                    :hint="$t('verify.phone_hint')"
            />

            <!-- Terms -->
            <Checkbox v-model="form.terms_confirmed" class="mt-4" :class="{ 'text-danger': !form.terms_confirmed }">
                <i18n path="verify.terms" tag="span">
                    <a href="https://hexeko.com/terms" target="_blank" :class="{ 'text-danger': !form.terms_confirmed }">{{ $t('verify.tos') }}</a>
                    <span>{{ $store.state.name }}</span>
                </i18n>
            </Checkbox>

            <!-- Opt-in -->
            <Checkbox v-model="form.opt_in" class="mt-1">
                {{ $t('verify.optin', { name: $store.state.name }) }}
            </Checkbox>

            <!-- Actions -->
            <FormActions class="text-center mt-5">
                <Submit large color="success" icon="check" @click="submit" :loading="submitting" :disabled="!form.submittable || !fieldsFilled">{{ $t('verify.submit') }}</Submit>
            </FormActions>

            <div class="mt-3">
                <a href="#" @click.prevent="logout" class="text-muted">
                    <Icon icon="angle-left" />
                    {{ $t('verify.logout') }}
                </a>
            </div>

        </FormRoot>
    </TransactionalScreen>
</template>

<script>
    import { TransactionalScreen, Form, Field, FormActions, Submit, FormRoot, Checkbox } from '@tech_hexeko/design-system'
    import { store } from "../../index"

    export default {
        components: {
            TransactionalScreen,
            Field,
            FormActions,
            Submit,
            FormRoot,
            Checkbox
        },
        data: function () {
            return {
                submitting: false,
                form: new Form({
                    first_name: null,
                    last_name: null,
                    email: null,
                    phone: null,
                    terms_confirmed: null,
                    opt_in: null,
                    locale: null
                })
            }
        },
        methods: {
            checkUserIsNotAlreadyVerified() {
                if(this.$store.getters['auth/passVerification']) {
                    this.next()
                }
            },
            submit() {
                this.submitting = true
                this.form.locale = this.$store.state.lang.displayLanguage
                // Update user
                this.form.submit(() => {
                    return this.$api.me.updateProfile(this.form.data())
                }).then(() => {
                    this.fetchUser()
                }).catch(() => {
                    this.submitting = false
                })
            },
            next() {
                let redirect = this.$route.query.redirect
                this.$router.push(redirect ? redirect : '/')
            },
            fetchUser() {
                this.$store.dispatch('auth/fetchUser');
            },
            logout() {
                this.$router.push({ name: 'logout' })
            },
            setLanguage(lang) {
                store.dispatch('lang/setLanguage', lang)
            }
        },
        computed: {
            user: function() {
                return this.$store.state.auth.user
            },
            fieldsFilled: function() {
                return this.form.first_name && this.form.last_name && this.form.email && this.form.phone && this.form.terms_confirmed
            }
        },
        watch: {
            user: {
                handler: function (user) {
                    // Check already verified
                    this.checkUserIsNotAlreadyVerified()
                    // Fill form
                    this.form.fillAsOriginalData({
                        first_name: user.first_name,
                        last_name: user.last_name,
                        email: user.email,
                        phone: user.phone,
                        terms_confirmed: !!user.terms_confirmed,
                        opt_in: !!user.opt_in
                    })
                },
                deep: true,
                immediate: true
            },
            'form': {
                deep: true,
                handler: function() {
                    this.form.keyUp()
                }
            }
        }
    }
</script>
